import React from 'react';
import classNameBind from 'classnames/bind';
import defaultStyles from './TextArea.module.css';

const bindClasses = classNameBind.bind(defaultStyles);

const TextArea = ({
  id,
  name,
  autoFocus,
  rows,
  value,
  placeholder,
  onChange,
  dataId,
  onBlur,
  error,
  touched,
  disabled,
}) => (
  <textarea
    {...{
      id,
      name,
      rows,
      value,
      autoFocus,
      placeholder,
      onChange,
      onBlur,
      readOnly: disabled,
    }}
    className={bindClasses('textarea', { disabled, invalid: error && touched })}
    data-ppuc-id={dataId}
  />
);

TextArea.defaultProps = {
  id: null,
  rows: 5,
  autoFocus: false,
  value: '',
  placeholder: '',
  disabled: false,
  dataId: 'TextArea',
};

export default TextArea;
